import fetch from "../../uilts/request.js";


export default {
    /**
     * 创建租赁合同
     */
    createZuLin(data) {
        return fetch.post('/Contract/createZuLin', data)
    },
    /**
     * 创建买卖合同
     */
    createMaiMaiContract(data) {
        return fetch.post('/Contract/createMaiMaiContract', data)
    },


    /**
     * 查看待签租赁合同
     */
    previewField7(data) {
        return fetch.post('/Contract/previewField7', data)
    },
    /**
     * 下载已签租赁合同
     */
    downField7(data) {
        return fetch.post('/Contract/downField7', data)
    },

    /**
     * 查看待签买卖合同
     */
    previewFileId(data) {
        return fetch.post('/Contract/previewFileId', data)
    },
    /**
     * 下载已签租赁合同
     */
    downFileId(data) {
        return fetch.post('/Contract/downFileId', data)
    }


}